module.exports = __webpack_public_path__ + "img/favicon.91db2b72.png";